import React from 'react';

interface MapOverlayProps {
  isVisible: boolean;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
}

const MapOverlay: React.FC<MapOverlayProps> = ({ isVisible, children, onClick }) => {
  if (!isVisible) return null;

  return (
    <div className="map-overlay" onClick={onClick}>
      {children}
    </div>
  );
};

export default MapOverlay;
